import React, { useState, useEffect } from "react"
import { Row, Col, Button, Modal, ModalHeader, ModalBody, Form, FormGroup, Label, Input } from "reactstrap"
import Datatables from "components/Datatables/datatable"
import Select from "react-select"
import { get, post } from "helpers/api_helper"
import { PAYROLL_GROUPS_URL, PAYROLL_COMPONENTS_URL } from "helpers/url_helper"
import Notifications from "components/Notifications"

const SalaryGroup = () => {
    const [modal, setModal] = useState(false)
    const [isEdit, setIsEdit] = useState(false)
    const [isLoading, setIsLoading] = useState(false)
    const [dataRows, setDataRows] = useState({ rows: [], total_rows: 0 })
    const [componentOptions, setComponentOptions] = useState([])
    const [pagination, setPagination] = useState({ limit: 10, page: 1, search: "" })
    
    const [formData, setFormData] = useState({
        name: "",
        component_ids: [],
        branch_id: "1"
    })

    const toggleModal = () => {
        if (modal) {
            setFormData({ name: "", component_ids: [], branch_id: "1" })
            setIsEdit(false)
        }
        setModal(!modal)
    }

    const brownBtnStyle = { backgroundColor: "#3d1e08", borderColor: "#3d1e08", color: "#fff" }

    const getData = async () => {
        setIsLoading(true)
        const res = await get(PAYROLL_GROUPS_URL)
        if (res.status === 200) {
            setDataRows(res.response)
        }
        setIsLoading(false)
    }

    const getComponents = async () => {
        const res = await get(`${PAYROLL_COMPONENTS_URL}?limit=100`)
        if (res.status === 200) {
            setComponentOptions(res.response.rows.map(item => ({ label: item.name, value: item.id })))
        }
    }

    useEffect(() => {
        getData()
        getComponents()
    }, [pagination])

    const handleSubmit = async (e) => {
        e.preventDefault()
        const res = isEdit 
            ? await post(`${PAYROLL_GROUPS_URL}_update`, formData)
            : await post(PAYROLL_GROUPS_URL, formData)
            
        if (res.status === 200 || res.status === true) {
            Notifications("success", res.message)
            toggleModal()
            getData()
        } else {
            Notifications("error", res.message)
        }
    }

    const handleEdit = (row) => {
        setFormData({ 
            ...row, 
            component_ids: row.component_ids ? row.component_ids.split(',') : [] 
        })
        setIsEdit(true)
        setModal(true)
    }

    const handleDelete = async (id) => {
        if (window.confirm("Are you sure you want to delete this group?")) {
            const res = await get(`${PAYROLL_GROUPS_URL}_delete?id=${id}`)
            if (res.status === 200 || res.status === true) {
                Notifications("success", res.message)
                getData()
            } else {
                Notifications("error", res.message)
            }
        }
    }

    const columns = [
        { dataField: "id", text: "#" },
        { dataField: "name", text: "NAME" },
        { 
            dataField: "component_ids", 
            text: "SALARY COMPONENTS",
            formatter: (cell) => {
                if (!cell) return "--"
                const ids = cell.split(',')
                return ids.length + " Components Selected"
            }
        },
        {
            dataField: "status",
            text: "IS ACTIVE",
            formatter: (cell) => (
                <div className="form-check form-switch" dir="ltr">
                    <input type="checkbox" className="form-check-input" defaultChecked={cell == 1} />
                </div>
            )
        },
        {
            dataField: "action",
            text: "ACTION",
            formatter: (cell, row) => (
                <>
                    <Button color="light" size="sm" className="me-1" onClick={() => handleEdit(row)}><i className="far fa-edit text-primary"></i></Button>
                    <Button color="light" size="sm" onClick={() => handleDelete(row.id)}><i className="far fa-times-circle text-danger"></i></Button>
                </>
            )
        }
    ]

    return (
        <React.Fragment>
            <Datatables 
                title="Salary Groups"
                titleClass="h5"
                columns={columns} 
                rows={dataRows.rows} 
                keyField="id" 
                rowsLength={dataRows.total_rows} 
                isSearch={false} 
                isAdd={true} 
                btnTitle="Add Salary Group"
                btnColor="success"
                handleAddButton={toggleModal}
                ssr={setPagination} 
                loading={isLoading} 
            />

            <Modal isOpen={modal} toggle={toggleModal} size="lg">
                <ModalHeader toggle={toggleModal}>{isEdit ? "Edit" : "Add"} Salary Group</ModalHeader>
                <ModalBody>
                    <Form onSubmit={handleSubmit}>
                        <Row>
                            <Col md={12}>
                                <FormGroup>
                                    <Label>Name <span className="text-danger">*</span></Label>
                                    <Input 
                                        type="text" 
                                        placeholder="Enter group name" 
                                        value={formData.name}
                                        onChange={(e) => setFormData({ ...formData, name: e.target.value })}
                                        required
                                    />
                                </FormGroup>
                            </Col>
                            <Col md={12}>
                                <FormGroup>
                                    <Label>Select Components <span className="text-danger">*</span></Label>
                                    <Select 
                                        isMulti 
                                        options={componentOptions} 
                                        value={componentOptions.filter(opt => formData.component_ids.includes(String(opt.value)))}
                                        placeholder="Select components..." 
                                        onChange={(opts) => setFormData({ ...formData, component_ids: opts ? opts.map(o => String(o.value)) : [] })}
                                    />
                                </FormGroup>
                            </Col>
                        </Row>
                        <div className="mt-3">
                            <Button style={brownBtnStyle} type="submit">{isEdit ? "Update" : "Create"}</Button>
                        </div>
                    </Form>
                </ModalBody>
            </Modal>
        </React.Fragment>
    )
}

export default SalaryGroup
